import $ from 'jquery';
import TomSelect from 'tom-select';
import {onViewportEnter} from '../helpers/lazyInit';

class TomSelectComponent {
	/**
	 * @param {ArrangementListPageContent} arrangementListPageContent
	 */
	constructor(arrangementListPageContent) {
		this.pageContent = arrangementListPageContent;
		this.pageType = null;
		this.searchKeyDownHandlerBounds = [];
	}

	/**
	 * @param {string} elementSelector
	 */
	init(elementSelector) {
		const me = this;
		
		me.tomSelectInstances = [];

		document.querySelectorAll(elementSelector).forEach((el) => {
			const placeholderText = (el.dataset.instanceid === 'event')
				? me.pageContent.params.dictionary.ts_filter.placeholder
				: me.pageContent.params.dictionary.opponent_event_filter.modal_title_text,

			 settings = {
				'render': {
					'option': function(data, escape) {
						return me.itemMarkup(data, escape(data.text));
					},
					'no_results': function() {
						return `<div class="no-results">${me.pageContent.params.dictionary.ts_filter.noResultsMessageText}</div>`;
					}
				},
				'plugins': {
					'remove_button': true
				},
				'hideSelected'    : false,
				'create'          : false,
				'createOnBlur'    : false,
				'placeholder'     : placeholderText,
				'placeholderValue': '',
				'maxOptions'   	  : 999_999,
				'sortField'       : [
					{'field': 'text', 'weight': 1, 'direction': 'asc'}
				],
				'searchField': ['text'],
				'score'      : function(search) {
					return function(item) {
						const itemText = item.text.replaceAll('\n', '').trim().toLowerCase(),
							searchTerm = search.toLowerCase();
				
						if (itemText === searchTerm) {
							// perfect match
							return 1;
						}
						
						if (itemText.startsWith(searchTerm.toLowerCase())) {
							// match at the beginning of the item text
							return 0.9;
						}
						
						if (itemText.indexOf(searchTerm) > 0) {
							// match elsewhere in the item text
							return 0.8;
						}
						
						// no match
						return 0;
					};
				}
			};

			let tomSelectInstance = null;

			if (el.classList.contains('tomselected')) {
				tomSelectInstance = el.tomselect.input.tomselect;
			} else {
				tomSelectInstance = new TomSelect(el, settings);
				me.tomSelectInstances.push(tomSelectInstance);
			}

			if (tomSelectInstance) {
				me.setOpponentSelectors(tomSelectInstance);
				$(tomSelectInstance.wrapper).removeClass('d-none');
			}

			const {dropdown} = tomSelectInstance,
				  dropdownControl = tomSelectInstance.control,
				  dropdownControlInput = tomSelectInstance.control_input,
				  droopdownContent = tomSelectInstance.dropdown_content,
				  allOpponentsOptionBtnWrapper = () => dropdown.querySelector('.allOpponentsOption-btnWrapper') || null,
				  allOpponentsOptionContent = () => dropdown.querySelector('.allOpponentsOption-content') || null;

			tomSelectInstance.on('change', () => {
				me.setOpponentSelectors(tomSelectInstance);
				me.pageContent.storeAllEventFilters();
				me.pageContent.storeAllSecondaryEventFilters();
				me.pageContent.getFilteredArrangements();

				me.pageType === 'event' && $(dropdown).addClass('d-block');
			});

			me.allOptions = null;
			tomSelectInstance.on('dropdown_open', () => {
				me.allOptions = tomSelectInstance.options;
				me.handleDropdownOpen(tomSelectInstance);
				me.togglePopularEventItems(tomSelectInstance, 'open');
			});

			tomSelectInstance.on('dropdown_close', () => {
				me.togglePopularEventItems(tomSelectInstance, 'close');
			});

			if (me.pageType === 'event') {
				const searchInputElement = dropdownControlInput;

				if (searchInputElement) {
					const searchKeyDownHandler = me.searchKeyDownHandler.bind(me);

					searchInputElement.addEventListener('keydown', searchKeyDownHandler);
					me.searchKeyDownHandlerBounds.push(searchKeyDownHandler);
				}
			} else {
				tomSelectInstance.on('type', () => {
					me.handleSearch(tomSelectInstance);
				});
			}

			if (me.pageType === 'event') {
				$(window).on('resize', () => {
					if (
						!(window.getComputedStyle(dropdown).display === 'none') &&
						!dropdown.classList.contains('d-none')
					) {
						me.toggleModalOpenedClass();
					}
				});
				
				document.addEventListener('click', (event) => {
					if (
						dropdown &&
						!dropdown.classList.contains('d-none') &&
						dropdownControl && !dropdownControl.contains(event.target) &&
						droopdownContent && !droopdownContent.contains(event.target) &&
						allOpponentsOptionBtnWrapper() && !allOpponentsOptionBtnWrapper().contains(event.target) &&
						allOpponentsOptionContent() && !allOpponentsOptionContent().contains(event.target)
					) {
						$(dropdown).addClass('d-none');
						$('html,body').removeClass('opponentFilterModalOpened');
					}
				});
			}
			
			if (tomSelectInstance.getValue().length > 0) {
				tomSelectInstance.settings.placeholder = '';
				tomSelectInstance.inputState();
			}
		});
	}

	/**
	 * @param {Event} event
	 */
	searchKeyDownHandler(event) {
		event.preventDefault();
	}

	/**
	 * @param {string} selectorString
	 * @param {boolean} byInstanceid
	 */
	removeEventsFromTomSelectInstace(selectorString, byInstanceid = false) {
		const me = this,
			  regex = /\.tomselect__(\w+)/g,
			  matches = selectorString.match(regex),
			  removeEvents = (selectorStringParam) => {
				const tomSelectInstance = me.getTomselectInstanceById(selectorStringParam);

				if (tomSelectInstance) {
					tomSelectInstance.off('change');
					tomSelectInstance.off('dropdown_open');
					tomSelectInstance.off('dropdown_close');
					tomSelectInstance.off('type');
				}
			  };

		if (matches) {
			const tomSelectInstanceIds = matches.map((match) => match.split('__')[1]);

			if (tomSelectInstanceIds.length > 0) {
				tomSelectInstanceIds.forEach((id) => {
					removeEvents(id);
				});
			}
		}

		if (byInstanceid) {
			removeEvents(selectorString);
		}
	}

	/**
	 * @param {{
	 * firstInit: boolean,
	 * response : Object
	 * }} params
	 */
	initFiltersBlock({firstInit, response}) {
		const me = this;

		let filteredDateRange = null;
		
		if (firstInit) {
			if (document.querySelector('.multiSelectField.isOnEventPage')) {
				me.pageType = 'event';
				me.init('.tomselect__secondary_event_eventpage');
			} else {
				me.pageType = 'arrangement_list';

				if (document.querySelector('.multiSelectField.isInFilterBlock')) {
					me.init('.tomselect__secondary_event, .tomselect__event');
				} else {
					me.init('.tomselect__event');
				}
			}

			(
				{filteredDateRange} = me.pageContent.params
			);
		} else if (response) {
			if (document.querySelector('.multiSelectField.isOnEventPage') === null) {
				let instanceSelector;
				
				me.pageType = 'arrangement_list';

				if (document.querySelector('.multiSelectField.isInFilterBlock')) {
					instanceSelector = '.tomselect__secondary_event, .tomselect__event';
					me.removeEventsFromTomSelectInstace(instanceSelector);
				}
				
				me.init(instanceSelector);
			} else {
				me.pageType = 'event';
			}

			(
				{filteredDateRange} = response
			);
		}

		const $dateSelector = $('.dateSelector');

		if (!$dateSelector.length) {
			return;
		}

		const hasDateRangeFilter = filteredDateRange && !!Object.keys(filteredDateRange).length;

		if (hasDateRangeFilter) {
			requestAnimationFrame(() => {
				me.pageContent.createFlatPickrElement($dateSelector, filteredDateRange);
			});
		} else {
			onViewportEnter(
				[$dateSelector[0]],
				() => {
					me.pageContent.createFlatPickrElement($dateSelector, filteredDateRange);
				},
				{
					'threshold': 1
				}
			);
		}
	}

	/**
	 * @param {Object} data
	 * @param {string} text
	 * @returns {string}
	 */
	itemMarkup(data, text) {
		const {popularEventsForAutocomplete} = this.pageContent.params,
			  isPopularEventItem = (popularEventsForAutocomplete) ? (popularEventsForAutocomplete.find((item) => item.value === parseInt(data.value))) : false;
		
		return `<label for="option-${data.value}" class="${isPopularEventItem ? '' : 'notPopularEventItem'}" ${isPopularEventItem ? '' : 'data-popularity="notPopularEventItem"'}">
					<span class="item-wrapper">
						<span class="item-checkmark-cell"><i class="checkmark" aria-hidden="true"></i></span>
						<span class="item-img-cell">${data?.imgsrc || ''}</span>
						<span class="item-text">${text}</span>
					</span>
				</label>`;
	}

	/**
	 * @param {TomSelect} tomSelectInstance
	 * @param {string} eventType
	 */
	togglePopularEventItems(tomSelectInstance, eventType) {
		const $container = $(tomSelectInstance.input).closest('.item-container'),
			  $tsDropdownItem = $container.find('.ts-dropdown .option');

		if (eventType === 'open' && tomSelectInstance.getValue().length > 0) {
				$tsDropdownItem.removeClass('notPopularEventItem');
			}

		if (eventType === 'close') {
			if (tomSelectInstance.getValue().length > 0) {
				$tsDropdownItem.removeClass('notPopularEventItem');
			} else {
				const $tsDropdownItemNotPopular = $tsDropdownItem.filter('[data-popularity=\'notPopularEventItem\']');

				$tsDropdownItemNotPopular.addClass('notPopularEventItem');
			}
		}

		if (eventType === 'type') {
			$tsDropdownItem.removeClass('notPopularEventItem');
		}
	}

	/**
	 * @param {Event} ev
	 * @param {TomSelect} tomSelectInstance
	 */
	toggleAllOpponents(ev, tomSelectInstance) {
		const me 				= this,
			allOptions 			= tomSelectInstance.options,
			values 				= [],
			$allOpponentsOption = $(ev.currentTarget);

		for (const key in allOptions) {
			if (Object.prototype.hasOwnProperty.call(allOptions, key)) {
				const option = allOptions[key];

				values.push(option.value);
			}
		}

		if ($allOpponentsOption.hasClass('selected')) {
			$allOpponentsOption.removeClass('selected');
			tomSelectInstance.dropdown_content.querySelectorAll('.option').forEach((option) => {
				$(option).removeClass('selected');
			});
			tomSelectInstance.clear();
			me.setOpponentSelectors(tomSelectInstance);
		} else {
			$allOpponentsOption.addClass('selected');
			tomSelectInstance.setValue(values);
		}
	}
	
	toggleModalOpenedClass() {
		const htmlElement = document.querySelector('html'),
			  bodyElement = document.querySelector('body'),
			  openedClassName = 'opponentFilterModalOpened',
			  mobileBreakpoint = 576;

		if (window.innerWidth < mobileBreakpoint) {
			htmlElement.classList.add(openedClassName);
			bodyElement.classList.add(openedClassName);
		} else {
			htmlElement.classList.remove(openedClassName);
			bodyElement.classList.remove(openedClassName);
		}

		$('html,body').toggleClass('opponentFilterModalOpened', $(window).width() < mobileBreakpoint);

		const $selectInput = $('.secondary_event_filter .ts-control > input');

		if ($(window).width() < mobileBreakpoint) {
			$selectInput.attr('readonly', 'true');
		} else {
			$selectInput.removeAttr('readonly');
		}
	}

	/**
	 * @param {TomSelect} tomSelectInstance
	 */
	handleDropdownOpen(tomSelectInstance) {
		const me = this,
			  $tsDropdown = $('.secondary_event_filter .ts-dropdown'),
			  $tsOption = $('.secondary_event_filter .ts-dropdown .option');
			
		$(tomSelectInstance.dropdown).removeClass('d-none');

		me.toggleModalOpenedClass();
		
		if ($tsDropdown.find('.allOpponentsOption').length === 0) {
			$tsDropdown.prepend($('.allOpponentsOption-container').html());
		}

		// These are came from the modal markup that we appended previously.
		const $allOpponentsOption = $('.secondary_event_filter .allOpponentsOption'),
			  $allOpponentsOptionOverlay = $('.secondary_event_filter .allOpponentsOption-overlay');

		// Need to hide the placeholder, because of a design requirement, and also need to hide the options when the input is not empty.
		// This code is needed for the arrangement list page-related filters.
		if (me.pageType === 'arrangement_list') {
			tomSelectInstance.settings.placeholder = '';
			tomSelectInstance.inputState();

			if (tomSelectInstance.getValue().length > 0) {
				tomSelectInstance.clearOptions();
				tomSelectInstance.refreshOptions(true);
				$(tomSelectInstance.input).closest('.item-container').find('.ts-dropdown .option').addClass('d-none');
			}
		}

		$allOpponentsOption.off().on('click', (ev) => {
			me.toggleAllOpponents(ev, tomSelectInstance);
		});

		$allOpponentsOptionOverlay.off().on('click', () => {
			tomSelectInstance.close();
		});

		$tsOption.off().on('click', (ev) => {
			ev.preventDefault();

			const $clicked 	= $(ev.currentTarget),
				  value 	= $clicked.data('value');
			
			if (
				$clicked.hasClass('selected')
			) {
				$clicked.removeClass('selected');
				ev.stopPropagation();
				tomSelectInstance.removeItem(value);
			} else {
				$clicked.addClass('selected');
				ev.stopPropagation();
				tomSelectInstance.addItem(value);
			}

			if (tomSelectInstance.items.length === Object.keys(tomSelectInstance.options).length) {
				$allOpponentsOption.addClass('selected');
			} else {
				$allOpponentsOption.removeClass('selected');
			}
		});

		this.pageContent.lazyLoadElements('.arrangementListItem .clubLogo, .option .clubLogo');
	}

	/**
	 * @param {!jQuery} wrapper
	 * @returns {Object}
	 */
	getOpponentSelectors(wrapper) {
		const opponentSelector 		= wrapper.find('.opponentSelector'),
			  opponentSelectorMore 	= opponentSelector.find('.opponentSelector-more'),
			  opponentSelectorItems = opponentSelector.find('.opponentSelector-items');

		return {
			'$opponentSelector'     : opponentSelector,
			'$opponentSelectorMore' : opponentSelectorMore,
			'$opponentSelectorItems': opponentSelectorItems
		};
	}

	/**
	 * @param {TomSelect} tomSelectInstance
	 */
	setOpponentSelectors(tomSelectInstance) {
		const me = this,
			  $tsWrapper = $('.secondary_event_filter .ts-wrapper'),
			  $opponentSelectorMoreText = this.pageContent.params.dictionary.opponent_event_filter.modal_title_all,
			  opponentSelectorMarkup = (concatenatedNames, selectedItemsNumber = 0) => `<div class="opponentSelector">
				<div class="opponentSelector-wrapper">
					<span class="opponentSelector-items">${concatenatedNames}</span> <span class="opponentSelector-more d-none">, +${selectedItemsNumber} ${$opponentSelectorMoreText}</span>
				</div>
			  </div>`;
	
		if (me.getOpponentSelectors($tsWrapper).$opponentSelector.length === 0) {
			$tsWrapper.prepend(opponentSelectorMarkup($(tomSelectInstance.control_input).attr('placeholder')));
		}

		// These are came from the modal markup that we appended previously.
		const {$opponentSelector, $opponentSelectorMore, $opponentSelectorItems} = me.getOpponentSelectors($tsWrapper),
			  selectedItemsNumber = tomSelectInstance.items.length;

		if (selectedItemsNumber > 0) {
			const items = [];

			for (const value of tomSelectInstance.items) {
				const item = $(tomSelectInstance.input).find(`option[value='${value}']`);

				if (item.length > 0) {
					items.push({'name': item.text().trim(), value});
				}
			}

			const names 			= items.map((item) => item.name),
				  allowedLimit 		= 1,
				  concatenatedNames = (selectedItemsNumber > allowedLimit) ? names.slice(0, allowedLimit).join(', ') : names.join(', ');

			$opponentSelector.remove();
			$tsWrapper.prepend(opponentSelectorMarkup(concatenatedNames, selectedItemsNumber - allowedLimit));

			if (selectedItemsNumber > allowedLimit) {
				me.getOpponentSelectors($tsWrapper).$opponentSelectorMore.removeClass('d-none');
			}
		} else {
			$opponentSelectorItems.html($(tomSelectInstance.control_input).attr('placeholder'));
			$opponentSelectorMore.html('');
		}
	}

	/**
	 * @param {string} instanceId
	 * @returns {Object|null} TomSelect instance
	 */
	getTomselectInstanceById(instanceId) {
		if (!this.tomSelectInstances) {
			return null;
		}

		let instance = null;

		this.tomSelectInstances.forEach((tomSelectInstance) => {
			if (tomSelectInstance.input.dataset.instanceid === instanceId) {
				instance = tomSelectInstance;
			}
		});

		return instance;
	}

	/**
	 * Need to search by the first letters of the option text.
	 * @param {TomSelect} tomSelectInstance
	 */
	handleSearch(tomSelectInstance) {
		const me = this,

		query = tomSelectInstance.lastQuery;

		if (query.length > 0) {
			const options = Object.values(this.allOptions),
				filteredOptions = options.filter((option) => {
					const optionText = option.text.replaceAll('\n', '').trim();

					return optionText.toLowerCase().startsWith(query.toLowerCase());
				}),
				filteredOptionsAnywhere = options.filter((option) => {
					let optionText = option.text;

					optionText = optionText.toLowerCase();

					return optionText.includes(query.toLowerCase());
				});
	
			let concattedFilteredOptions = [...filteredOptions, ...filteredOptionsAnywhere];
	
			concattedFilteredOptions = concattedFilteredOptions.reduce((acc, current) => {
				const duplicate = acc.find((option) => option.value === current.value);

				if (!duplicate) {
					acc.push(current);
				}

				return acc;
			}, []);

			tomSelectInstance.clearOptions();

			concattedFilteredOptions.forEach((option) => {
				tomSelectInstance.addOption(option);
			});
			
			tomSelectInstance.refreshOptions(true);

			me.setOpponentSelectors(tomSelectInstance);
			me.togglePopularEventItems(tomSelectInstance, 'type');
		}
	}

}

export default TomSelectComponent;